/* eslint-disable react/require-default-props */
/* eslint-disable react/no-danger */
import React from 'react';
import PartnerLogo from 'components/atoms/partner_logo';
import { FollowupTypes } from 'store/modules/bidding_store/types';
import moment from 'moment';
import { ApplicationState } from 'store';
import { useSelector } from 'react-redux';
import { ProfileState } from 'store/modules/profile_store/types';
import { FollowupData } from 'store/modules/followup_store/types';
import { Container } from './styles';

interface BiddingFollowupItemProps {
  followup: FollowupTypes | FollowupData;
}

const BiddingFollowupItem = (props: BiddingFollowupItemProps) => {
  const { followup } = props;

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  return (
    <Container>
      <div className="card shadow followup-info-border mb-4">
        <div className="card-body">
          <div className="row bidding-info mb-2">
            <div className="col-md-1 text-left text-md-right pr-0 bidding-info-title">
              Data Fonte
            </div>
            <div className="col-md-2">{moment(followup.data_fonte).format('L')}</div>

            <div className="col-md-2 text-left text-md-right pr-0 bidding-info-title mt-2 mt-md-0">
              Nº Conlicitação
            </div>
            <div className="col-md-3">{followup.id}</div>
          </div>

          <div className="row bidding-info mb-2">
            <div className="col-md-1 text-left text-md-right p-md-0 bidding-info-title">
              Sintese
            </div>
            <div className="col-md-11" dangerouslySetInnerHTML={{ __html: followup.sintese }} />
          </div>
          {profile.partner_user && <PartnerLogo partnerSourceId={followup.licitacao_fonte_id} />}
        </div>
      </div>
    </Container>
  );
};

export default BiddingFollowupItem;
